import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BACKEND_API_URL } from "../../config";

const initialState = {
  data: {}, 
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
}

export const fetchInitialState = createAsyncThunk(
  'Summary/fetch', 
  async (data, { getState, dispatch }) => {
    const {token} = getState().navigator;
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding-summary?token=${token}`);
        if (response.status === 401) {
          window.location.reload()
          throw new Error('Failed to fetch initial state');
        }
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const initialState = await response.json();
        // console.log(initialState);
        return initialState.data;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return initialState.data
      }
  })



// Slice

export const summarySlice = createSlice({
    name: 'Summary',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
          // FETCH
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
      },
  });

export default summarySlice.reducer;
  